import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconLongForm = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 30 30"
      data-fill-none
    >
      <path
        d="M1.875 1.375C1.59886 1.375 1.375 1.59886 1.375 1.875V8C1.375 8.27614 1.59886 8.5 1.875 8.5H28.125C28.4011 8.5 28.625 8.27614 28.625 8V1.875C28.625 1.59886 28.4011 1.375 28.125 1.375H1.875Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 24.125C1.59886 24.125 1.375 24.3489 1.375 24.625V28.125C1.375 28.4011 1.59886 28.625 1.875 28.625H28.125C28.4011 28.625 28.625 28.4011 28.625 28.125V24.625C28.625 24.3489 28.4011 24.125 28.125 24.125H1.875Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 11.875C1.59886 11.875 1.375 12.0989 1.375 12.375V20.25C1.375 20.5261 1.59886 20.75 1.875 20.75H28.125C28.4011 20.75 28.625 20.5261 28.625 20.25V12.375C28.625 12.0989 28.4011 11.875 28.125 11.875H1.875Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 20.6875C15.2416 20.6875 15.4375 20.8834 15.4375 21.125L15.4375 23.75C15.4375 23.9916 15.2416 24.1875 15 24.1875C14.7584 24.1875 14.5625 23.9916 14.5625 23.75L14.5625 21.125C14.5625 20.8834 14.7584 20.6875 15 20.6875Z"
        fill="currentColor"
      />
      <path
        d="M13.25 22L15 23.3464L16.75 22"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 14.125C4.5 13.8834 4.69588 13.6875 4.9375 13.6875L23.3125 13.6875C23.5541 13.6875 23.75 13.8834 23.75 14.125C23.75 14.3666 23.5541 14.5625 23.3125 14.5625L4.9375 14.5625C4.69587 14.5625 4.5 14.3666 4.5 14.125Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 16.3125C4.5 16.0709 4.69588 15.875 4.9375 15.875L23.3125 15.875C23.5541 15.875 23.75 16.0709 23.75 16.3125C23.75 16.5541 23.5541 16.75 23.3125 16.75L4.9375 16.75C4.69587 16.75 4.5 16.5541 4.5 16.3125Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 18.5C4.5 18.2584 4.69587 18.0625 4.9375 18.0625L11.0625 18.0625C11.3041 18.0625 11.5 18.2584 11.5 18.5C11.5 18.7416 11.3041 18.9375 11.0625 18.9375L4.9375 18.9375C4.69587 18.9375 4.5 18.7416 4.5 18.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.625 4.0625C3.625 3.82087 3.82087 3.625 4.0625 3.625L10.1875 3.625C10.4291 3.625 10.625 3.82088 10.625 4.0625C10.625 4.30412 10.4291 4.5 10.1875 4.5L4.0625 4.5C3.82087 4.5 3.625 4.30412 3.625 4.0625Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.625 5.8125C3.625 5.57088 3.82087 5.375 4.0625 5.375L15.4375 5.375C15.6791 5.375 15.875 5.57088 15.875 5.8125C15.875 6.05412 15.6791 6.25 15.4375 6.25L4.0625 6.25C3.82087 6.25 3.625 6.05412 3.625 5.8125Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 26.375C4.5 26.1334 4.69587 25.9375 4.9375 25.9375L14.5625 25.9375C14.8041 25.9375 15 26.1334 15 26.375C15 26.6166 14.8041 26.8125 14.5625 26.8125L4.9375 26.8125C4.69587 26.8125 4.5 26.6166 4.5 26.375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8.4375C15.2416 8.4375 15.4375 8.63337 15.4375 8.875L15.4375 11.5C15.4375 11.7416 15.2416 11.9375 15 11.9375C14.7584 11.9375 14.5625 11.7416 14.5625 11.5L14.5625 8.875C14.5625 8.63337 14.7584 8.4375 15 8.4375Z"
        fill="currentColor"
      />
      <path
        d="M13.25 10L15 11.3464L16.75 10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
